import { Chip } from '@jotpsych/ui';

import { BLOCKED_ON_LABELS } from '../copy';
import { PARTY_CHIP_COLOR } from '../stateTokens';
import type { BlockedParty } from '../types';

export interface BlockedOnChipProps {
  party: BlockedParty;
}

/** AC-14: the roster's "Blocked on" chip. */
export function BlockedOnChip({ party }: BlockedOnChipProps) {
  return (
    <Chip
      label={BLOCKED_ON_LABELS[party]}
      color={PARTY_CHIP_COLOR[party]}
      variant="soft"
      size="xSmall"
      sx={{ fontWeight: 600 }}
    />
  );
}
